import axios from 'axios'

const LOCALHOSTS = new Set(['localhost', '127.0.0.1', '::1'])

function resolveApiUrl() {
  const envUrl = import.meta.env.VITE_API_URL?.trim()

  if (typeof window !== 'undefined') {
    const isLocalHost = LOCALHOSTS.has(window.location.hostname)

    if (isLocalHost) {
      return envUrl || 'http://localhost:8787'
    }

    return envUrl && !envUrl.includes('localhost') ? envUrl : 'https://w.camp.sciuskku15.com'
  }

  return envUrl && !envUrl.includes('localhost') ? envUrl : 'https://w.camp.sciuskku15.com'
}

const API_URL = resolveApiUrl()

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// Handle auth errors
api.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response?.status === 401) {
    // Clear auth data and redirect to login
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    window.location.href = '/login'
  }
  return Promise.reject(error)
})

export const authAPI = {
  login: (studentId, password) =>
    api.post('/api/auth/login', { studentId, password }),
  changePassword: (oldPassword, newPassword) =>
    api.post('/api/auth/change-password', { oldPassword, newPassword }),
  logout: () =>
    api.post('/api/auth/logout'),
  getMe: () =>
    api.get('/api/auth/me'),
}

export const staffAPI = {
  getAll: () =>
    api.get('/api/staff'),
  getMgmt: () =>
    api.get('/api/staff-mgmt'),
  updateRole: (studentId, role) =>
    api.put(`/api/staff-mgmt/${studentId}/role`, { role }),
  updateTeams: (studentId, teams) =>
    api.put(`/api/staff-mgmt/${studentId}/teams`, { teams }),
  updateStations: (studentId, stations) =>
    api.put(`/api/staff-mgmt/${studentId}/stations`, { stations }),
}

export const stationAPI = {
  getAll: () =>
    api.get('/api/stations'),
  create: (name) =>
    api.post('/api/stations', { name }),
  update: (id, name) =>
    api.put(`/api/stations/${id}`, { name }),
  delete: (id) =>
    api.delete(`/api/stations/${id}`),
}

export const scoreAPI = {
  create: (teamId, scoreType, amount, stationId, note) =>
    api.post('/api/scores', { teamId, scoreType, amount, stationId, note }),
  getLeaderboard: () =>
    api.get('/api/scores/leaderboard'),
  getHistory: (teamId) =>
    api.get('/api/scores/history', { params: teamId ? { teamId } : {} }),
  getAllHistory: () =>
    api.get('/api/scores/history'),
}

export const teamsAPI = {
  getAll: () =>
    api.get('/api/teams'),
}

export default api
